
export enum Collection {
	Settings = 'settings',
	Greetings = 'greetings',
	Choices = 'choices',
	Areas = 'areas',
	Inserts = 'inserts',
	Tags = 'food-tags',
	Pages = 'pages',
	Page = 'page',
	Verticals = 'verticals',
	CloudImage = 'cimg',
	Image = 'image',
}
